angular.module('app').directive('trsDetailCtrl', function(){
    return {
        scope: true,
        restrict: 'AE',
        templateUrl: './resourceCenter/directive/trsDetailCtrl/trsDetailCtrl_tpl.html',
        replace: true,
        transclude: {
            'left': '?leftBtn',
            'right': '?rightBtn',
        },
        link: function($scope, iElm, iAttrs, controller) {
            initStatus();

            /**
             * 初始化状态
             */
            function initStatus(){
                $scope.status = {
                    btns: iAttrs.btns,
                };
            }
            $scope.isShowBtn = function(type){
                return $scope.status.btns.indexOf(type) !== -1;
            };
        }
    };
});
